import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type CreateRemoveBackgroundOperationMutationVariables = Types.Exact<{
  input: Types.CreateRemoveBackgroundOperationInput;
}>;


export type CreateRemoveBackgroundOperationMutation = { __typename?: 'Mutation', createRemoveBackgroundOperation?: { __typename?: 'FireflyOperationPayload', fireflyOperation?: { __typename?: 'FireflyOperation', id?: string | null, destination?: { __typename?: 'FolderAsset', id: string } | null } | null } | null };


export const CreateRemoveBackgroundOperation = /*#__PURE__*/ gql`
    mutation CreateRemoveBackgroundOperation($input: CreateRemoveBackgroundOperationInput!) {
  createRemoveBackgroundOperation(input: $input) {
    fireflyOperation {
      id
      destination {
        id
      }
    }
  }
}
    ` as unknown as DocumentNode<CreateRemoveBackgroundOperationMutation, CreateRemoveBackgroundOperationMutationVariables>;

          

          export const useCreateRemoveBackgroundOperationMutation = (options?:MutationHookOptions<CreateRemoveBackgroundOperationMutation, CreateRemoveBackgroundOperationMutationVariables>) => useMutation(CreateRemoveBackgroundOperation, options);
          

          export type CreateRemoveBackgroundOperationMutationOptions = MutationHookOptions<CreateRemoveBackgroundOperationMutation, CreateRemoveBackgroundOperationMutationVariables>;

          

          export type CreateRemoveBackgroundOperationMutationResult = ReturnType<typeof useCreateRemoveBackgroundOperationMutation>[1];

          
